import React from "react"
import styled from "styled-components"

const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  height: 100px;
  justify-content: center;
  align-items: center;
  width: 100%;
  img {
    max-width: 100px;
    max-height: 32px;
  }

  @media (min-width: 768px) {
    img {
      width: 100%;
      height: fit-content;
      max-width: fit-content;
      max-height: fit-content;
    }
  }

  ${({ border }) =>
    border &&
    `
    border: 1px solid #D5D4F9;
    border-radius: 8px;
    padding: 30px 30px;
    box-sizing: border-box;
    p:first-child, h3:first-child {
      margin-top: 0px;
    }
    p:last-child {
      margin-bottom: 0px;
    }
  `}
  ${({ background }) =>
    background &&
    `
    background: ${background}
  `}
`

const Card = ({ card, cardWidth = 360, background, border }) => {
  return (
    <StyledCard cardWidth={cardWidth} background={background} border={border}>
      {card}
    </StyledCard>
  )
}

const ImageGridWrapper = styled.div`
  flex-basis: 100%;
  @media screen and (min-width: 768px) {
    flex-basis: unset;
  }
`

const StyledImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  grid-gap: 24px;
  place-items: center;
  flex-wrap: wrap;
  justify-content: center;

  @media screen and (min-width: 768px) {
    max-width: ${({ maxWidth }) => maxWidth + "px"};
    grid-template-columns: repeat(${({columns}) => columns}, 1fr);
  }
`

const ImageGrid = ({ cards, border, cardWidth, background, maxWidth, columns = 4 }) => {
  return (
    <ImageGridWrapper>
      <StyledImageGrid maxWidth={maxWidth}  columns={columns}>
        {cards.map((card, i) => {
          return (
            <Card
              key={`imagegrid__card--${card?.props?.alt}--${i}`}
              card={card}
              cardWidth={cardWidth}
              background={background}
              border={border}
            />
          )
        })}
      </StyledImageGrid>
    </ImageGridWrapper>
  )
}

export default ImageGrid
